import _ from 'lodash';
import { apiFetch, apiSearch } from '../utility';

const apiBase = 'rackTransfer';
const RACK_TRANSFER_RESULT = 'accounting/rackTransfer/SEARCH/';
const RACK_TRANSFER_STATUS_CHANGE = 'accounting/rackTransfer/CHANGE';

const initialState = {
	byStationId: {},
	byStatus: {},
};

export default (state = initialState, action) => {
	if (action.type === RACK_TRANSFER_RESULT) {
		if (action.stationId) {
			return {
				...state,
				byStationId: {
					...state.byStationId,
					[action.stationId]: _.map(action.rackTransfers, 'rackTransferIds'),
				},
			};
		} else if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.rackTransfers, 'rackTransferId'),
				},
			};
		} else {
			return state;
		}
	} else if (action.type === RACK_TRANSFER_STATUS_CHANGE) {
		const { status, rackTransferId } = action.rackTransfer;

		const pendingIds = _.get(state, ['byStatus', 'pending']);
		const invalidIds = _.get(state, ['byStatus', 'invalid']);
		const issuedIds = _.get(state, ['byStatus', 'issued']);
		if (!pendingIds || !issuedIds) {
			return state;
		}

		//- New pending invoice. Means we have a new invoice
		if (status === 'pending') {
			const newPendingIds = _.uniq(pendingIds.concat([rackTransferId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
				},
			};
		}

		//- New invalid invoice. Means we have a new invoice
		if (status === 'invalid') {
			const newInvalidIds = _.uniq(invalidIds.concat([rackTransferId]));
			const newPendingIds = _.filter(pendingIds, (id) => {
				return id !== rackTransferId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					invalid: newInvalidIds,
				},
			};
		}

		if (status === 'issued') {
			const newIssuedIds = _.uniq(issuedIds.concat([rackTransferId]));
			const newPendingIds = _.filter(pendingIds, (id) => {
				return id !== rackTransferId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					issued: newIssuedIds,
				},
			};
		}
	} else {
		return state;
	}
};

export const search = (p) => {
	const { status, stationId, afterDate, callback = _.noop } = p;

	return (dispatch) => {
		const params = {
			status,
			afterDate,
			stationId,
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}

				const rackTransfers = _.get(r, ['collections', 'rackTransferCollection']);
				dispatch({
					type: RACK_TRANSFER_RESULT,
					status,
					stationId,
					rackTransfers,
				});
				callback();
			},
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const invalidate = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}
				const rackTransfer = _.get(r, ['collections', 'rackTransferCollection', 0]);
				dispatch({
					type: RACK_TRANSFER_STATUS_CHANGE,
					rackTransfer,
				});
				callback();
			},
		});
	};
};

export const searchLogs = ({ rackTransferId, callback = _.noop }) => {
	return (dispatch) => {
		apiSearch({
			method: 'rackTransfer.log.search',
			base: 'rackTransferLog',
			keyBy: rackTransferId,
			params: {
				rackTransferId,
			},
			dispatch,
			callback,
		});
	};
};

export const advancedSearch = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'rackTransfer.advancedSearch',
			params,
			dispatch,
			callback,
		});
	};
};
